import { seatable } from './utils'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'

export const convertFacilityGroupsSpacesToPoints = ({ ids, byId }) => {
  const sp = ids.reduce((result, id) => {
    const s = byId[id]
    return seatable(s.spaceType) ? [...result, s] : result
  }, [])

  return sp.map((pro) => {
    const { x, y, w, code, spaceAssignment } = pro
    const point = [x, y]
    point.w = w
    point.facilityGroup = get(spaceAssignment, 'employee.facilityGroup')
    point.code = code

    return point
  })
}

export const groupFacilityGroupCluster = (cluster) =>
  groupBy(cluster, ({ facilityGroup }) => get(facilityGroup, 'id'))
